import React from "react";
import { inject, observer } from "mobx-react";
import BroadcastStore from "../_stores/broadcast/BroadcastStore";
import usePausedShowCountdown from "../usePausedShowCountdown";

interface Props {
  broadcastStore?: BroadcastStore;
}

const MobileBroadcastPausedCounter: React.FC<Props> = ({ broadcastStore }) => {
  const { restoreFreeShow, broadcasterVariant } = broadcastStore!;
  const timer = usePausedShowCountdown(restoreFreeShow, broadcasterVariant);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100dvh",
        zIndex: 100,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <div
        style={{
          fontSize: "80px",
          fontWeight: "bold",
          color: "white",
          textAlign: "center",
        }}>
        {timer}
      </div>
    </div>
  );
};

export default inject("broadcastStore")(observer(MobileBroadcastPausedCounter));
